export const ImageURLGenerator = (name: string, size: "sm" | "lg") => {
  return `https://www.artthread.org${name}_${size}.jpg`;
};
